export const manifestLocales = {
  audio: {
    previewImageAlt: {
      en: 'audio widget',
      he: 'אודיו',
      ar: 'audio widget [AR]'
    }
  }
};
